import { saveAs } from "file-saver";

export const Download = {
  Excel: (data: string, name_file: string) => {
    const base64Data = data;
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(undefined)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, name_file);
  },
  Pdf: (data: string, name_file: string) => {
    const base64Data = data.replace(/^data:application\/pdf;base64,/, ""); // Loại bỏ prefix nếu có
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(undefined)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "application/pdf" });
    saveAs(blob, name_file);
  },
};
